import {Dispatch} from "redux";
import {BrandsAPI} from "../services/api/Api";
import {IBrands} from "../constants/types";

export const GET_ALL_BRANDS_START = 'CatalogBrands/GET_ALL_BRANDS_START';
export const GET_ALL_BRANDS_SUCCESS = 'CatalogBrands/GET_ALL_BRANDS_SUCCESS';

interface ICatalogBrandsState {
    isLoading: boolean,
    allBrands: Array<IBrands>
}

interface ICatalogBrandsAction {
    type: string,
    payload: Array<IBrands>
}

const initialState: ICatalogBrandsState = {
    isLoading: true,
    allBrands: []
};

const setAllBrands = (res: Array<IBrands>) => ({
    type: GET_ALL_BRANDS_SUCCESS,
    payload: res
});

export const getAllBrands = () => (dispatch: Dispatch)=> {
    dispatch({type: GET_ALL_BRANDS_START});
    BrandsAPI.getBrands()
        .then(res => dispatch(setAllBrands(res)))
        .catch(e => console.log(e))
};

const AllBrandsReducer = (state = initialState, action: ICatalogBrandsAction): ICatalogBrandsState => {

    switch (action.type) {

        case GET_ALL_BRANDS_START:
            return {
                ...state,
            };

        case GET_ALL_BRANDS_SUCCESS:
            return {
                ...state,
                allBrands: action.payload,
                isLoading: false
            };

        default:
            return state;
    }
};

export default AllBrandsReducer;
